<script setup lang="ts">
interface NewsEntry {
  id: string
  title: string
  slug: string
  datePosted: string
}

const props = defineProps<{
  data: NewsPage,
  entries: NewsEntry[],
}>()

const formatDatePosted = (datePosted: string) => getFormattedDate(datePosted)
</script>

<template>
  <div class="contents">
    <ul v-if="entries.length > 0" class="flex flex-col gap-1 mx-1">
      <li v-for="entry in entries" :key="entry.id">
        <site-link
          :route-object="{
            name: 'news-slug',
            params: { slug: entry.slug },
          }"
          class="block hover:text-accent text-md"
        >
          <div
            v-if="formatDatePosted(entry.datePosted)"
          >
            {{ formatDatePosted(entry.datePosted) }}
          </div>
          <div>
            {{ entry.title }}
          </div>
        </site-link>
      </li>
    </ul>
  </div>
</template>
